var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-content"},[_c('global-header',{attrs:{"school":1,"title":'학교 방문예약'}}),_c('div',{staticClass:"unused"},[_vm._v(" 학교 방문예약시스템을 사용하지 않는 학교입니다. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }